export default {
  postagePageTitle: 'Store-level Delivery Fee'
}
